export const FLOW_ID_KEY = 'adSubmissionFlowId';
